import { borderWidths } from '../borders.js';
import { radii } from '../radius.js';
export const checkboxBase = {
    cursor: 'pointer',
};
export const checkboxIcon = {
    borderWidth: borderWidths.sm,
    borderRadius: radii.x1,
};
export const checkboxIconStates = {
    inactive: {
        borderColor: 'form',
        backgroundColor: 'white',
    },
    hover: {
        borderColor: 'primary',
        backgroundColor: 'white',
    },
    active: {
        borderColor: 'primaryActive',
        backgroundColor: 'primaryActive',
    },
};
//# sourceMappingURL=checkbox.js.map